import React, { Component, Fragment } from 'react';
import Header from '../../../components/Layout/Header/HeaderSubmitBill';
import { headerScreenLabels } from '../../../common/common-types';
import AlertMessage from '../../../common/AlertMessage/AlertMessage';
import MyRoute from '../../../hoc/MyRoute';
import Profile from './Profile';
import { connect } from 'react-redux';

const mapStateToProps = (state) => {
	return {
		uploadingStatus: state.reducerBillUploadProgress.uploadingStatus
	};
};

class ProfileContainer extends Component {
	componentDidMount() {
		window.scrollTo(0, 0);
	}
	render() {
		return (
			<Fragment>
				<Header screenLabel={headerScreenLabels.myprofile} />
				<AlertMessage />
				<MyRoute billUploadStatus={this.props.uploadingStatus}>
					<Profile />
				</MyRoute>
			</Fragment>
		);
	}
}

export default connect(mapStateToProps)(ProfileContainer);
